import styled from 'styled-components';
import { IonCard } from '@ionic/react';

export const IonCardWrapper = styled(IonCard)`
  .date-label {
    font-size: 0.8em;
    font-weight: bold;
  }
  
  .avatar-skeleton {
    max-width: 20px;
    max-height: 20px;
  }
  
  .thumbnail-skeleton {
    max-width: 50px;
    max-height: 50px;
  }
  
  .ellipsis-wrap {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  } 
`;
